module.exports = __webpack_public_path__ + "static/media/browDownRight.c19b3f48.obj";